import { render, staticRenderFns } from "./RiderRateCard.vue?vue&type=template&id=3c1c1a32&scoped=true&"
import script from "./RiderRateCard.vue?vue&type=script&lang=js&"
export * from "./RiderRateCard.vue?vue&type=script&lang=js&"
import style0 from "./RiderRateCard.vue?vue&type=style&index=0&id=3c1c1a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c1a32",
  null
  
)

export default component.exports